import React from 'react'
import { ReactComponent } from './edit-document.svg'
import { MergeReactElementProps } from '../types'

interface EditDocumentProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', EditDocumentProps>

export const EditDocument = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
